import { Alert } from "../model/internal/alert";
import * as alert from "../constants/alert";

export const buildAlertForError = (error: Error, startofDescription: string): Alert => {
  return {
    type: alert.ERROR,
    className: alert.DANGER,
    messages: [{ description: `${startofDescription}: ${error.message ?? ""}` }],
  };
};
